"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moneyService = _interopRequireDefault(require("../services/moneyService"));
var _excluded = ["amount", "isFancy", "large", "useCurrencySign", "targetAmount", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function WBMFormatMoney(props) {
  var amount = props.amount,
    isFancy = props.isFancy,
    large = props.large,
    useCurrencySign = props.useCurrencySign,
    targetAmount = props.targetAmount,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var amt = _moneyService["default"].explodeMoney(amount);
  var style = getAmountStyle(amount, targetAmount);
  var innerContent = !isFancy ? "".concat(useCurrencySign ? "$" : "").concat(amt[0]).concat(_moneyService["default"].addCommas(amt[1]), ".").concat(amt[2]) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "superscript"
  }, amt[0], "$"), _moneyService["default"].addCommas(amt[1]), /*#__PURE__*/_react["default"].createElement("span", {
    className: "superscript"
  }, amt[2]));
  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "".concat(style ? style : "", " ").concat(className)
  }, rest), large ? /*#__PURE__*/_react["default"].createElement("h3", null, innerContent) : innerContent);
}
function getAmountStyle(amount, targetAmount) {
  if (amount > 0 && amount < targetAmount) {
    return "text-danger";
  } else if (amount > 0 && amount >= targetAmount) {
    return "text-success";
  } else {
    //no style
    return null;
  }
}
WBMFormatMoney.propTypes = {
  isFancy: _propTypes["default"].bool,
  amount: _propTypes["default"].number.isRequired,
  className: _propTypes["default"].string,
  targetAmount: _propTypes["default"].number,
  large: _propTypes["default"].bool,
  useCurrencySign: _propTypes["default"].bool
};
WBMFormatMoney.defaultProps = {
  className: ""
};
var _default = WBMFormatMoney;
exports["default"] = _default;
//# sourceMappingURL=wbmFormatMoney.js.map